import { render, staticRenderFns } from "./DayPrices.vue?vue&type=template&id=193c097f&"
import script from "./DayPrices.vue?vue&type=script&lang=js&"
export * from "./DayPrices.vue?vue&type=script&lang=js&"
import style0 from "./DayPrices.vue?vue&type=style&index=0&lang=sass&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports